import type { PropsWithChildren } from 'react';

import Header from '@/components/common/Header';

const AuthFormWrapper = ({ children }: PropsWithChildren) => (
  <section className='min-h-screen w-full flex flex-col'>
    <Header />

    <div className={'flex justify-center items-center relative flex-grow'}>
      <div className='w-[80%] md:w-[60%] lg:w-[30%] flex justify-center items-center relative'>
        {children}
      </div>
    </div>
  </section>
);

export default AuthFormWrapper;
